export default function PrivacyPolicy() {
  return (
    <div className="prose">
      <h1>Echo Steps — Privacy Policy</h1>
      <p>Last updated: {new Date().toLocaleDateString()}</p>

      <p>
        Echo Steps ("we", "us", or "our") respects your privacy. This Privacy
        Policy explains how we collect, use, disclose, and protect information
        when you use the Echo Steps mobile application and this website
        (together, the "Services").
      </p>

      <h2>1. Information We Collect</h2>
      <p>
        We designed Echo Steps to collect the minimum information necessary.
        Depending on how you use the Services, we may collect:
      </p>
      <ul>
        <li>
          <strong>Device Information</strong>: device model, OS version, app
          version, and basic diagnostics.
        </li>
        <li>
          <strong>Usage Data</strong>: interactions within the app such as
          session length and screens viewed.
        </li>
        <li>
          <strong>Support Information</strong>: if you contact us, we receive
          the email message and any attachments you send.
        </li>
      </ul>

      <h2>2. How We Use Information</h2>
      <ul>
        <li>Provide, maintain, and improve the Services.</li>
        <li>Understand usage patterns and ensure reliability and security.</li>
        <li>Respond to your questions and support requests.</li>
        <li>Comply with legal obligations.</li>
      </ul>

      <h2>3. Legal Bases</h2>
      <p>
        Where applicable (e.g., EEA/UK/Israel), we process information based on
        legitimate interests in operating and improving the Services, consent
        where required, and compliance with legal obligations.
      </p>

      <h2>4. Sharing and Disclosure</h2>
      <p>
        We do not sell your personal information. We may share information with
        service providers that help us operate the Services (such as analytics,
        error reporting, and hosting). These providers are bound by
        confidentiality and data protection obligations and may only use
        information on our instructions. We may disclose information if required
        by law, legal process, or to protect rights, property, or safety of
        users and the public.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain information only for as long as necessary for the purposes
        described in this Policy, to resolve disputes, establish legal defenses,
        conduct audits, and enforce agreements.
      </p>

      <h2>6. Children</h2>
      <p>
        Echo Steps is intended for general audiences and not directed to
        children under 13 (or the age of digital consent in your jurisdiction).
        We do not knowingly collect personal information from children. If you
        believe a child has provided personal information, please contact us to
        request deletion.
      </p>

      <h2>7. International Transfers</h2>
      <p>
        We may process information in countries other than your own. When we
        transfer information internationally, we take appropriate safeguards as
        required by law.
      </p>

      <h2>8. Your Rights</h2>
      <p>
        Depending on your location, you may have rights to access, correct,
        delete, or restrict certain processing of your information. You may also
        object to processing based on legitimate interests and withdraw consent
        where provided. To exercise rights, contact us using the details below.
      </p>

      <h2>9. Security</h2>
      <p>
        We implement reasonable administrative, technical, and organizational
        measures to protect information. No method of transmission or storage is
        100% secure; we cannot guarantee absolute security.
      </p>

      <h2>10. Third-Party Links</h2>
      <p>
        The Services may contain links to third-party sites or services. We are
        not responsible for their privacy practices. We encourage you to review
        their policies.
      </p>

      <h2>11. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Material changes
        will be posted here with a new "Last updated" date. Your continued use
        of the Services after changes constitutes acceptance of the updated
        Policy.
      </p>

      <h2>12. Contact</h2>
      <p>
        Email:{" "}
        <a href="mailto:support@echo-steps.com">support@echo-steps.com</a>
        <br />
        Address: Echo Steps, 21 Herzl St, Tel Aviv-Yafo, 66000, Israel
      </p>

      <p className="tiny">
        This Policy is provided for transparency and does not create contractual
        or legal rights on behalf of any party beyond those required by
        applicable law.
      </p>
    </div>
  );
}
